Vue.component('vq-newsletter', {
    delimiters: ['[[', ']]'],
    // inject: ['$validator'],
    mixins: [baseMixin, apiMixin],
    data: function () {
        return {
            model: {},
            label: 'newsletter',
            validate: 'email',
            placeholder: gettext('Votre email'),
            button_content: gettext('S\'abonner'),
            success_message: gettext("Merci pour votre inscription ! Vous recevrez nos prochaines actualités sur cet email."),
            isDisplay: true
        }
    },
    computed: {
    },
    methods: {
        classesValidation() {
            return {
                'is-valid': (!this.errors.has(this.name) && this.model.value != '') || (!this.errors.has(this.name) && typeof this.model.value == 'boolean'),
                'is-error': this.errors.has(this.name)
            }
        },
        sendNewsletter() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.post('newsletter', { site_id: window.site_id, email: this.model.value }).then((response) => {
                        this.isDisplay = false;
                    })
                }
            })
        }
    },
    template: `<form class="flex-column tab:flex-row" @submit.prevent="sendNewsletter()">
    <template v-if="isDisplay">
        <div class="full-w">
            <vq-input name="footer-newsletter" :placeholder="placeholder" :model.sync="model" type="text" validate="email">
            </vq-input>
        </div>
        <button class="btn is-tertiary">[[button_content]]<i class="icon icon-envelope"></i></button>
    </template>
    <p class="fw-bold c-primary-dark" v-if="!isDisplay">[[success_message]]</p>
</form>
`
})
